import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { FaBars, FaTimes } from 'react-icons/fa';

// Styled Components
const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Logo = styled(Link)`
  font-family: 'Playfair Display', serif;
  font-size: 1.75rem; /* Default for large screens */
  font-weight: 700;
  color: #1e3a8a;
  text-decoration: none;
  transition: all 0.3s ease;

  /* Responsive font sizes */
  @media (max-width: 768px) {
    font-size: 1.5rem; /* Tablet */
  }

  @media (max-width: 480px) {
    font-size: 1.25rem; /* Mobile */
  }
`;


const NavLinks = styled.nav`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: ${props => props.isOpen ? '0' : '-100%'};
    width: 250px;
    height: 100vh;
    background-color: white;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 5rem;
    transition: right 0.3s ease;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  }
`;

const NavLink = styled(Link)`
  margin: 0 1rem;
  color: #1f2937;
  text-decoration: none;
  font-weight: 500;
  position: relative;
  transition: all 0.3s ease;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #f59e0b;
    transition: width 0.3s ease;
  }
  
  &:hover, &.active {
    color: #1e3a8a;
    
    &:after {
      width: 100%;
    }
  }
  
  @media (max-width: 768px) {
    margin: 1rem 0;
    color: #1f2937;
    text-shadow: none;
  }
`;

const BookNowButton = styled(Link)`
  background-color: #f59e0b;
  color: white;
  padding: 0.5rem 1.25rem;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  margin-left: 1rem;
  
  &:hover {
    background-color: #d97706;
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    margin: 1.5rem 0 0;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #1e3a8a;
  z-index: 1001;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const CloseButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #1f2937;
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1002;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  
  // Close menu when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);
  
  // Check if link is active
  const isActive = (path) => {
    return location.pathname === path;
  };
  
  return (
    <HeaderContainer>
      <NavContainer>
        <Logo to="/">Wular water front resort</Logo>
        
       {!menuOpen && (
  <MenuButton 
    onClick={() => setMenuOpen(true)}
    aria-label="Open menu"
  >
    <FaBars />
  </MenuButton>
)}
        
        <NavLinks isOpen={menuOpen}>
          <CloseButton 
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            <FaTimes />
          </CloseButton>
          
          <NavLink 
            to="/" 
            className={isActive('/') ? 'active' : ''}
          >
            Home
          </NavLink>
          
          <NavLink 
            to="/about"
            className={isActive('/about') ? 'active' : ''}
          >
            About
          </NavLink>
          
          <NavLink 
            to="/activities"
            className={isActive('/activities') ? 'active' : ''}
          >
            Activities
          </NavLink>
          
          <NavLink 
            to="/rooms"
            className={isActive('/rooms') ? 'active' : ''}
          >
            Rooms
          </NavLink>
          
          <NavLink 
            to="/gallery"
            className={isActive('/gallery') ? 'active' : ''}
          >
            Gallery
          </NavLink>
          
          <NavLink 
            to="/contact"
            className={isActive('/contact') ? 'active' : ''}
          >
            Contact
          </NavLink>
          
          <BookNowButton to="/booking">Book Now</BookNowButton>
        </NavLinks>
      </NavContainer>
    </HeaderContainer>
  );
};

export default Header;
